import bg2 from "../assets/images/bg_2.png";
import bg3 from "../assets/images/bg_3.png";
import GrabLogo from "../assets/images/grabLogo.png";
import grabFoodExample from "../assets/images/grabFoodExample.png";

function GrabFood() {
  return (
    <div
      id="background"
      style={{ backgroundImage: `url(${bg3})`, backgroundSize: "100% auto", backgroundRepeat: "no-repeat", backgroundPosition: "0 -200px" }}
    >
      <section className="py-12 px-4 md:py-20 text-left md:-mb-1" id="home">
        <div className="container mx-auto max-w-6xl">
          <div className="md:flex md:gap-12">
            <div className="md:w-2/3">
              <p className="text-xl font-semibold text-grab pt-2">GrabFood POS Integration</p>

              <h2 className="text-4xl md:text-6xl font-bold my-4">Manage Grab Orders Directly in VernPOS</h2>

              <p className="text-lg text-gray-600">
                Connect your POS with Grab to receive orders, manage sales in one system, and streamline daily operations.
              </p>

              <div className="flex flex-col sm:flex-row space-y-4 sm:space-y-0 sm:space-x-4 mt-8">
                <a
                  href="/contact-us"
                  className="border-2 border-grab text-grab hover:text-green-600 hover:border-green-200 py-3 rounded-full text-lg font-medium inline-block md:w-1/3 text-center"
                >
                  Request Demo
                </a>
                <a
                  href="https://pos.vernpos.my/business/register?package=6"
                  className="bg-grab hover:bg-green-100 text-white py-3 rounded-full text-lg font-medium inline-block md:w-1/3 text-center"
                >
                  Get Started
                </a>
              </div>
            </div>

            <div className="md:w-1/2 flex items-center justify-center md:justify-end mt-8 md:mt-0">
              <img src={GrabLogo} alt="GrabLogo" className="max-w-xs md:max-w-md" />
            </div>
          </div>
        </div>
      </section>

      <section
        className="py-12 px-4 md:py-16 bg-[#F6F6F7]"
        style={{
          backgroundImage: `url(${bg2})`,
          backgroundSize: "100% auto",
          backgroundRepeat: "repeat",
          backgroundPosition: "0 -200px",
          borderWidth: "2px",
          borderColor: "#EDEDED",
          borderStyle: "solid",
        }}
      >
        <div className="max-w-6xl mx-auto">
          {/* Header */}
          <p className="text-xl font-semibold text-grab">GrabFood POS Integration</p>

          <h2 className="text-4xl md:text-6xl font-bold mt-4 mb-12">How It Works</h2>

          {/* Steps */}
          <div className="space-y-10">
            {/* Step 1 */}
            <div className="flex items-start gap-6">
              <div className="flex shrink-0 items-center justify-center w-12 h-12 rounded-full bg-grab text-white font-bold text-lg">1</div>

              <div>
                <h3 className="text-2xl font-semibold text-gray-900">Connect Your Accounts</h3>
                <p className="text-gray-600 mt-1">Sign in to Grab Merchant → Link to VernPOS with a secure API token.</p>
              </div>
            </div>

            {/* Step 2 */}
            <div className="flex items-start gap-6">
              <div className="flex shrink-0 items-center justify-center w-12 h-12 rounded-full bg-grab text-white font-bold text-lg">2</div>

              <div>
                <h3 className="text-2xl font-semibold text-gray-900">Sync Menu & Pricing</h3>
                <p className="text-gray-600 mt-1">Import your Grab menu into VernPOS or keep items unified across channels.</p>
              </div>
            </div>

            {/* Step 3 */}
            <div className="flex items-start gap-6">
              <div className="flex shrink-0 items-center justify-center w-12 h-12 rounded-full bg-grab text-white font-bold text-lg">3</div>

              <div>
                <h3 className="text-2xl font-semibold text-gray-900">Order Flow Automation</h3>
                <p className="text-gray-600 mt-1">
                  Grab orders flow directly into VernPOS - printed, notified, and fulfilled like your in-store POS orders.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-12 px-4 md:py-16 bg-white" id="home">
        <div className="max-w-6xl mx-auto">
          {/* Header */}
          <p className="text-xl font-semibold text-grab">GrabFood POS Integration</p>

          <h2 className="text-4xl md:text-6xl font-bold mt-4 mb-12">Benefits</h2>

          {/* List */}
          <div className="divide-y divide-gray-200">
            {/* Row 1 */}
            <div className="grid grid-cols-1 md:grid-cols-12 py-8 gap-4 md:gap-0 items-start">
              <div className="md:col-span-4 flex gap-6 items-center">
                <span className="text-2xl font-semibold text-gray-800">1</span>

                <h3 className="text-2xl font-semibold text-gray-900 leading-tight">Centralized order management</h3>
              </div>

              <p className="text-lg md:col-span-8 text-gray-600">View and process Grab orders alongside in-store sales in one POS system.</p>
            </div>

            {/* Row 2 */}
            <div className="grid grid-cols-1 md:grid-cols-12 py-8 gap-4 md:gap-0 items-start">
              <div className="md:col-span-4 flex gap-6 items-center">
                <span className="text-2xl font-semibold text-gray-800">2</span>
                <h3 className="text-2xl font-semibold text-gray-900 leading-tight">Reduced manual work</h3>
              </div>

              <p className="text-lg md:col-span-8 text-gray-600">Orders are sent directly to VernPOS, minimising re-entry and staff errors.</p>
            </div>

            {/* Row 3 */}
            <div className="grid grid-cols-1 md:grid-cols-12 py-8 gap-4 md:gap-0 items-start">
              <div className="md:col-span-4 flex gap-6 items-center">
                <span className="text-2xl font-semibold text-gray-800">3</span>
                <h3 className="text-2xl font-semibold text-gray-900 leading-tight">Consistent menu management</h3>
              </div>

              <p className="text-lg md:col-span-8 text-gray-600">Keep item names and pricing aligned between Grab and VernPOS.</p>
            </div>

            {/* Row 4 */}
            <div className="grid grid-cols-1 md:grid-cols-12 py-8 gap-4 md:gap-0 items-start">
              <div className="md:col-span-4 flex gap-6 items-center">
                <span className="text-2xl font-semibold text-gray-800">4</span>
                <h3 className="text-2xl font-semibold text-gray-900 leading-tight">Improved operational visibility</h3>
              </div>

              <p className="text-lg md:col-span-8 text-gray-600">See order status, sales performance, and peak periods more clearly.</p>
            </div>

            <img src={grabFoodExample} alt="GrabFood Example" className="w-full mt-12 rounded-lg shadow-md" />
          </div>
        </div>
      </section>

      <section className="py-12 px-4 md:py-16 bg-[#F6F6F7]">
        <div className="container mx-auto max-w-6xl">
          <h2 className="text-4xl md:text-5xl font-bold my-4 text-center">INTEGRATE GRABFOOD WITH VERNPOS</h2>
        </div>
        <a
          href="https://pos.vernpos.my/business/register?package=6"
          className="bg-vern hover:bg-red-100 text-white py-3 px-6 rounded-full text-lg font-medium flex items-center justify-center gap-2 md:w-1/5 mx-auto mt-8"
        >
          Get Started Now
          <svg className="w-5 h-5" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9 19L16 12L9 5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </a>
      </section>
    </div>
  );
}

export default GrabFood;
